import React from 'react'
import PropTypes from 'prop-types'
import EditableButton from '@v4/components/common/EditableButton'
import { useLinkButton } from './LinkButton.hooks'

const LinkButton = props => {
	const [{ children, href, className, editable, rest, targetProps }, { handleClick, handleChange }] = useLinkButton(
		props,
	)

	return (
		<EditableButton
			{...rest}
			className={className}
			component="a"
			href={href}
			{...targetProps}
			onClick={handleClick}
			editable={editable}
			onChange={handleChange}
		>
			{children}
		</EditableButton>
	)
}

LinkButton.propTypes = {
	children: PropTypes.string,
	href: PropTypes.string,
	className: PropTypes.string,
	onClick: PropTypes.func,
	onChange: PropTypes.func,
	editable: PropTypes.bool,
	variant: PropTypes.oneOf(['filled', 'outlined']),
	color: PropTypes.oneOf(['white', 'primary', 'secondary', 'text']),
	primaryColor: PropTypes.string,
}

export default LinkButton
